import React from "react";
import type {VoidFunctionComponent} from "react";
import s from "./RecentLessonCards.module.scss";
import {RecentLessonCard} from "../recent-lesson-card/RecentLessonCard";
import {NoRecentLessons} from "../no-recent-lessons/NoRecentLessons";
import {IDashboardPageRecentlyPlayedLesson} from "../../store/IDashboardPageStore";

export interface IRecentLessonCards {
  lessons: IDashboardPageRecentlyPlayedLesson[];
}

export const RecentLessonCards: VoidFunctionComponent<IRecentLessonCards> = ({lessons}: IRecentLessonCards) => {
  if (lessons.length === 0) {
    // don't have any lessons
    return <NoRecentLessons />;
  }
  return (
    <div className={s.recentLessonCards}>
      {lessons.map((recentlyPlayedLesson) => {
        const {lessonId, segmentId} = recentlyPlayedLesson;
        return <RecentLessonCard key={`recent-lesson-${lessonId}-${segmentId}`} {...recentlyPlayedLesson} />;
      })}
    </div>
  )
}
